<template>
  <b-modal id="adicionar-avaliacao-geral-modal" size="lg" centered header-bg-variant="secondary"
    header-text-variant="light" title="Nova Requisição" @hidden="$emit('fecharModal')"
    :no-close-on-esc="isLoading" :no-close-on-backdrop="isLoading" :hide-header-close="isLoading">
    <template v-slot:modal-footer="">
      <b-button @click="clickMe" :disabled="isLoading">
        <b-spinner small v-if="isLoading"></b-spinner>
        <span class="d-none d-md-inline ml-1 px-2">Salvar</span>
      </b-button>
    </template>
    <b-row>
      <b-col cols="12" xl="6">
        <div class="form-group">
          <label for="input-url">URL Transparência</label>
          <b-form-input v-model="url" placeholder="https://meu.endereco" :disabled="isLoading" />
        </div>

      </b-col>
      <b-col cols="12" xl="3">
        <div class="form-group">
          <label for="select-metrica">Métrica</label>
          <b-form-select id="select-metrica" v-model="metrica" :options="listaMetricaSelect" @change="carregarAno">
          </b-form-select>
        </div>

      </b-col>
      <b-col cols="12" xl="3">
        <div class="form-group">
          <label for="select-ano">Ano</label>
          <b-form-select id="select-ano" v-model="ano" :options="listaAno"
            :disabled="!metrica || listaAno.length === 0">
          </b-form-select>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import serigyService from "@/services/administracao/serigyService";
import { MetricaAvaliacaoGeral } from "@/types/administracao/serigy/avaliacao-geral/metrica";
import ResizeHelper from "@/mixins/resize-helper.mixin";

const CompProps = Vue.extend({
  name: "ModalAddRequisicaoInvoker",
});

@Component
export default class ModalAddRequisicaoInvoker extends mixins(
  UtilsTS,
  CompProps,
  ResizeHelper,
) {
  isLoading = false
  url = ''
  metrica = 0
  ano = 0
  listaMetrica: MetricaAvaliacaoGeral[] = []
  listaMetricaSelect: { value: number; text: string }[] = []
  listaAno: { value: number; text: string }[] = []

  async clickMe(): Promise<void> {
    try {
      this.isLoading = true
      if (this.url === '' || this.metrica === 0 || this.ano === 0) {
        this.$toast.error('Preencha todos os campos', { timeout: 1000 })
        return
      }
      const response = await serigyService.adicionarAvaliacao(this.url, this.metrica, this.ano)
      this.url = ''
      this.metrica = 0
      this.ano = 0
      this.$emit('fecharModal', true)
      this.$toast.success('Avaliação adicionada', { timeout: 1000 })
    } catch (e: unknown) {
      this.tratarError(e)
    } finally {
      this.isLoading = false
    }
  }

  carregarAno(): void {
    const metricaSelecionada = this.listaMetrica.find(m => m.id === this.metrica)
    if (metricaSelecionada) {
      this.listaAno = metricaSelecionada.metricaAnuals.map((value) => ({ value: value.ano, text: value.ano.toString() }))
    } else {
      this.listaAno = []
    }
  }

  async mounted(): Promise<void> {
    try {
      this.listaMetrica = await serigyService.listarMetricasAvaliacaoGeral()
      this.listaMetricaSelect = this.listaMetrica.map(metrica => ({ value: metrica.id, text: metrica.metricaDs }))
      this.$bvModal.show("adicionar-avaliacao-geral-modal");
    } catch (e: unknown) {
      console.log('e', e)
      this.tratarError(e)
    }
  }
}
</script>
